import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getWorkPackages = async (params = {}) => {
  const response = await axiosInstance.get(`${API_URL}/work-packages`, { params });
  return response.data;
};

export const getWorkPackageById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/work-packages/${id}`);
  return response.data;
};

export const createWorkPackage = async (workPackageData) => {
  const response = await axiosInstance.post(`${API_URL}/work-packages`, workPackageData);
  return response.data;
};

export const shareWorkPackage = async (workPackageData) => {
  const response = await axiosInstance.post(`${API_URL}/work-packages/share`, workPackageData);
  return response.data;
};

export const updateWorkPackage = async (id, workPackageData) => {
  const response = await axiosInstance.put(`${API_URL}/work-packages/${id}`, workPackageData);
  return response.data;
};

export const deleteWorkPackage = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/work-packages/${id}`);
  return response.data;
};

export const resendWorkAssignmentSms = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/work-packages/send-assignment-sms`, payload);
  return response.data;
};

export const resendWorkAssignmentEmail = async (payload) => {
  const response = await axiosInstance.post(`${API_URL}/work-packages/send-assignment-email`, payload);
  return response.data;
};
